import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';

export const ConsentStep = ({ formData, update }) => (
  <div className="space-y-5" data-testid="intake-step-consent">
    <h2 className="text-2xl font-bold text-darkBrown mb-2">Family History & Consent</h2>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Family Mental Health History</label>
      <Textarea rows={4} value={formData.familyMentalHealthHistory} onChange={(e) => update('familyMentalHealthHistory', e.target.value)} placeholder="List any mental health conditions in your immediate family (parents, siblings, grandparents)..." className="resize-none" />
    </div>

    <div className="border-t pt-6 mt-6">
      <h3 className="text-lg font-semibold text-darkBrown mb-3">HIPAA Acknowledgment</h3>
      <div className="bg-warmBeige p-4 rounded-lg mb-4 text-sm text-gray-700 max-h-40 overflow-y-auto">
        <p className="mb-2">I acknowledge that I have been informed of the practice&apos;s Notice of Privacy Practices, which describes how my protected health information (PHI) may be used and disclosed.</p>
        <p className="mb-2">I understand that FAVOR HCS will use my health information for treatment, payment, and healthcare operations as permitted by HIPAA.</p>
        <p>I understand that I have the right to request restrictions on how my information is used, and to receive a copy of this notice upon request.</p>
      </div>
      <label className="flex items-center gap-3 cursor-pointer" data-testid="intake-hipaa-checkbox">
        <input
          type="checkbox"
          checked={formData.hipaaConsent}
          onChange={(e) => update('hipaaConsent', e.target.checked)}
          className="w-5 h-5 rounded border-gray-300 text-primaryOrange focus:ring-primaryOrange"
        />
        <span className="text-sm font-medium text-darkBrown">I acknowledge and agree to the HIPAA Privacy Practices *</span>
      </label>
    </div>

    <div className="space-y-1 pt-4">
      <label className="text-sm font-medium text-darkBrown">Electronic Signature (Type your full name) *</label>
      <Input
        data-testid="intake-signature"
        value={formData.consentSignature}
        onChange={(e) => update('consentSignature', e.target.value)}
        placeholder="Type your full legal name"
        className="italic text-lg"
        required
      />
      <p className="text-xs text-gray-400 mt-1">By typing your name, you agree this serves as your electronic signature.</p>
    </div>
  </div>
);
